<template>
  <v-list-item class="note-card">
    <v-list-item-content>
      <div class="note-top">
        <v-row class="ma-0">
          <span class="note-date">{{ formatDate(note.created_at) }}</span>
          <v-spacer/>
          <v-chip small :color="statusColor" dark>{{ statusLabel }}</v-chip>
        </v-row>
      </div>
      <div class="note-comment">{{ note.comment }}</div>
      <v-row class="ma-0 note-meta-row">
        <v-col cols="6" class="pa-0">
          <div class="note-meta">De: {{ userName(note.from_user) }}</div>
          <div class="note-meta">Para: {{ userName(note.to_user) }}</div>
        </v-col>
        <v-col cols="6" class="pa-0 text-right">
          <div class="note-meta">Empresa: {{ companyLabel }}</div>
          <div class="note-meta">Contacto: {{ contactLabel }}</div>
        </v-col>
      </v-row>
    </v-list-item-content>
    <div class="note-actions">
      <v-tooltip bottom v-if="allowReadActions && canMarkRead">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small v-bind="attrs" v-on="on" @click="$emit('mark-read', note)">
            <v-icon small color="#707073">mdi-check-all</v-icon>
          </v-btn>
        </template>
        <span>Marcar leida</span>
      </v-tooltip>
      <v-tooltip bottom v-if="allowReadActions && canMarkDone">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small v-bind="attrs" v-on="on" @click="$emit('mark-done', note)">
            <v-icon small color="success">mdi-check-circle</v-icon>
          </v-btn>
        </template>
        <span>Marcar realizada</span>
      </v-tooltip>
      <v-tooltip bottom v-if="allowEdit">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small v-bind="attrs" v-on="on" @click="$emit('edit', note)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip bottom v-if="allowDelete">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small v-bind="attrs" v-on="on" @click="$emit('delete', note)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Eliminar</span>
      </v-tooltip>
    </div>
  </v-list-item>
</template>

<script>
export default {
  props: {
    note: {
      type: Object,
      required: true,
    },
    allowReadActions: {
      type: Boolean,
      default: false,
    },
    allowEdit: {
      type: Boolean,
      default: false,
    },
    allowDelete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    companyLabel() {
      if (this.note.company && this.note.company.attributes) {
        return this.note.company.attributes.name || this.note.company.attributes.razon_social || 'Sin empresa'
      }
      return 'Sin empresa'
    },
    contactLabel() {
      if (this.note.contact && this.note.contact.attributes) {
        return [this.note.contact.attributes.name, this.note.contact.attributes.last].filter(Boolean).join(' ')
      }
      return 'Sin contacto'
    },
    statusLabel() {
      return this.normalizeSeen(this.note.seen)
    },
    statusColor() {
      const seen = this.normalizeSeen(this.note.seen)
      if (seen === 'Pendiente') {
        return 'grey'
      }
      if (seen === 'Leido') {
        return 'warning'
      }
      return 'success'
    },
    canMarkRead() {
      return this.normalizeSeen(this.note.seen) === 'Pendiente'
    },
    canMarkDone() {
      return this.normalizeSeen(this.note.seen) === 'Leido'
    },
  },
  methods: {
    normalizeSeen(value) {
      if (value === null || value === undefined) {
        return 'Pendiente'
      }
      const normalized = String(value).trim().toLowerCase()
      if (normalized === 'pendiente' || normalized === 'null') {
        return 'Pendiente'
      }
      if (normalized === 'leido') {
        return 'Leido'
      }
      if (value === false || value === 0 || value === '0') {
        return 'Leido'
      }
      if (normalized === 'realizado' || normalized === 'realizada') {
        return 'Realizado'
      }
      if (value === true || value === 1 || value === '1') {
        return 'Realizado'
      }
      return 'Pendiente'
    },
    userName(user) {
      if (!user) {
        return 'Sin usuario'
      }
      return [user.name, user.last].filter(Boolean).join(' ')
    },
    formatDate(value) {
      if (!value) {
        return ''
      }
      return new Date(value).toLocaleString()
    },
  },
}
</script>

<style scoped>
.note-card {
  align-items: flex-start;
  border-bottom: 1px solid #f0e2b3;
  background:transparent!important;
}
.note-top {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.note-top-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.note-date {
  font-size: 12px;
  color: #8a7b4f;
}
.note-comment {
  font-size: 15px;
  line-height: 21px;
  color: #665f47;
  margin: 10px 0px 15px;
  background:rgba(255, 255, 255, 0.5);
  padding:7px 15px;
}
.note-meta {
  font-size: 12px;
  color: #8a7b4f;
}
.note-actions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 8px;
  padding-top: 6px;
}
</style>
